module.exports = __webpack_public_path__ + "static/media/map.b41e85ea.png";